import { MenuItem } from "api/config/model/AppConfigResponseModel";
import { TbLogout } from "react-icons/tb";

export class Route {
  constructor(
    public key: string,
    public name: string,
    public path: string,
    public icon: any,
    public componentName: string,
    public code?: string,
    public subMenu?: any,
  ) {}
}

export const HOST_MENUS: MenuItem[] = [
  new MenuItem("Đăng nhập", "sign-in", "SignInPage", "SignIn", TbLogout),
  new MenuItem(
    "Quên mật khẩu",
    "forgot-password",
    "ForgotPassword",
    "forgot-password",
    TbLogout,
  ),
];
